import React from "react";
import { Table } from "semantic-ui-react";
import styles from "./OrdersListRow.module.scss";
import { Order } from "../../../types/orderTypes";
import { Link } from "react-router-dom";
import PrimaryButton from "../../../components/Button/PrimaryButton";
import { HiPencilAlt } from "react-icons/hi";
import { FormattedMessage } from "react-intl";
import dayjs from "dayjs";

const OrdersListRow = ({
  order: { _id, isPaid, totalPrice, paidAt },
}: {
  order: Order;
}) => {
  return (
    <Table.Row>
      <Table.Cell>
        <small>{_id}</small>
      </Table.Cell>
      <Table.Cell>
        {isPaid ? (
          <>
            {" "}
            <FormattedMessage id="order.summary.isPaid" />{" "}
            {dayjs(paidAt).format("MMMM D, YYYY h:mm A")}
          </>
        ) : (
          <FormattedMessage id="order.summary.isNotPaid" />
        )}
      </Table.Cell>
      <Table.Cell>{totalPrice}</Table.Cell>

      <Table.Cell className={styles.row}>
        <Link to={`/order/${_id}`} className={styles.item}>
          <PrimaryButton size="small">
            <HiPencilAlt size={18} />
          </PrimaryButton>
        </Link>
      </Table.Cell>
    </Table.Row>
  );
};

export default OrdersListRow;
